import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { Observable } from 'rxjs';
import { PlatformReservation, AlloxApiService, PlatformDeliveryType, ResponseTsvData } from "@app/core";
import { PlatformReservationSearchParam } from "../models";

@Injectable({ providedIn: 'root' })
export class PlatformReservationService {

  private path = '/platform_reservations';

  constructor(private http: AlloxApiService) { }

  /**
   * 配信PF予約登録を検索する
   *
   * @remarks 配信PF予約登録 検索APIを呼び出す
   * @param {PlatformReservationSearchParam} param - 配信PF予約登録の検索パラメータ
   * @returns 配信PF予約登録情報(複数)
   */
  public search(param?: PlatformReservationSearchParam): Observable<PlatformReservation[]> {
    let query = '';
    if (param) {
      query += param.toFlattenURLQuery();
    }
    return this.http.get<[]>(this.path + query).pipe(
      map(objs => objs.map(obj => new PlatformReservation(obj)))
    );
  }

  /**
   * 配信PF予約登録を取得する
   *
   * @remarks 配信PF予約登録 参照APIを呼び出す
   * @param id - 配信PF予約登録ID
   * @returns 配信PF予約登録情報(単体)
   */
  public fetch(id: number): Observable<PlatformReservation> {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new PlatformReservation(obj))
    );
  }

  /**
   * 配信PF予約登録を削除する
   *
   * @remarks 配信PF予約登録 削除APIを呼び出す
   * @param items - 配信PF予約登録情報(複数)
   * @returns 空のレスポンス
   */
  public deletes(items: PlatformReservation[]): Observable<void> {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }

  /**
   * 配信PF予約登録を登録する
   *
   * @remarks 配信PF予約登録 作成APIを呼び出す
   * @param item - 配信PF予約登録情報(単体)
   * @returns 空のレスポンス
   */
  public post(item: PlatformReservation): Observable<any> {
    const json: any = item.toJSON();
    return this.http.post(this.path, json);
  }

  /**
   * 配信PF予約登録を更新する
   *
   * @remarks 配信PF予約登録 編集APIを呼び出す
   * @param item - 配信PF予約登録情報(単体)
   * @returns 空のレスポンス
   */
  public put(item: PlatformReservation): Observable<any> {
    const json: any = item.toJSON();

    return this.http.put(this.path + '/' + item.id, json);
  }

  /**
   * 配信PF予約登録を一括登録する
   *
   * @remarks 配信PF予約登録 一括登録APIを呼び出す
   * @param url - 配信PF予約一括登録用スプレッドシートのURL
   * @returns 一括登録の成否のエラーレスポンス(成功時: 空のレスポンス、失敗時: エラー情報)
   */
  public batchPost(url: string): Observable<void> {
    return this.http.post(this.path + '/batch', { url: url });
  }

  /**
 * Returns TSV download information
 *
 * @remarks
 * This method communicates the TSV download API and returns the information necessary for download
 *
 * @param param Placement Relation Search Criteria
 * @returns TSV data and file name
 */
  public export(param: PlatformReservationSearchParam) {
    const json = param.toJSON();
    return this.http.post(this.path + '/export', json).pipe(
      map(obj => new ResponseTsvData(obj))
    );
  }

}
